import React, { useEffect, useRef, useState } from 'react';
import * as echarts from 'echarts';
import { useStoreUpdaterWithAPI } from '../../../Hooks/UseStoreUpdaterWithApi';
import { calculateDateRangeFromDate } from '../../../Utils/DateConverstion';
import { APIConstants } from '../../../Common/APIConstants';
import { Button, Form, Input, Modal, notification, Select, Space } from 'antd';
import { useSelector } from 'react-redux';
import { MoreOutlined, CloseOutlined } from "@ant-design/icons";

const Gauge3 = (props) => {
  const chartRef = useRef(null);
  const isdarkMode=props.theme;
  console.log(isdarkMode)
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [gauge,setGauge] = useState([]);  
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
    const {makeRequest} = useStoreUpdaterWithAPI();


    const handleNotification = (msg, type = "success") => {
        notification.open({
          message: msg,
          type: type, 
          placement: 'topRight',  
          duration: 3, 
        });
      };

    const getReposnse =()=>{
        // setLoading(true)
        const currentDate = new Date(); 

        const { from, to } = calculateDateRangeFromDate(currentDate, 5, 2);

        const inputData = {
        // ConverterID: Number(lgConvId),
        // MeterIds: ids,
        FromDate: from,  
        ToDate:to,
        }; 
        console.log('getReposnse')
        console.log(to, from)   

        
        try {      
        makeRequest({
            type: APIConstants.GET,     
            // http://20.244.40.160:83/SF6VCBConsumptiontrend?FromDate=2024-08-20%2006%3A00%3A00.000&ToDate=2024-08-20%2007%3A00%3A00.000
            url:`${APIConstants.GAUGES_LIVE_CURRENT}?FromDate=${from}&ToDate=${to}`
            // url:`${APIConstants.LUCAS_LIVE_GAUGE}?FromDate=2024%2F08%2F13%2006%3A30%3A00&ToDate=2024%2F08%2F13%2006%3A30%3A00`
            // token:token, 
            // body:chartInput      
        }).then((res) => {  
            console.log('response' )
            console.log(res)       
            // console.log(TransformGaugeChartData(res[0])) 
            if (res&& res.length ) {
            setGauge(res);              
            }
            // console.log(TransformGaugeChartData(res[0]));              
            // setGauge(TransformGaugeChartData(dummy[0]));

            
            

        });
        // console.log('function  called') 
        
        } catch (error) {
        // setError(true);
        console.log(error);
        }  

    }


    useEffect(()=>{
        getReposnse()
        const intervalId = setInterval(() => {
            getReposnse();
        }, 60000); // 60000 milliseconds = 1 minute

        return () => clearInterval(intervalId); // Cleanup on unmount
    },[props.theme,props.refetch]) 
        

  useEffect(() => {
    console.log(gauge)
    // if (loading || !data1 || !data2) return;
    var min = 0;
        var max = 80;
        var step = (max - min) / 5; // 20% interval, so 5 steps
        var axisLabels = Array.from({ length: 6 }, (_, i) => (min + i * step).toFixed(2));

    const myChart = echarts.init(chartRef.current);

    const option = {
      backgroundColor: isdarkMode === 'dark'? '#070721' : '#fff',
      title: {
        text: props.title||'',
        left: 'center',
        // top: '5px',
        textStyle: {
          color: isdarkMode === 'dark'? 'white' : 'black',
           fontWeight: "normal",
           padding: [0, 0, 10, 0],
        },
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: { type: 'shadow' },
        confine: true,
      },
      legend: {
        bottom: '0px',
        textStyle: {
          color: isdarkMode === 'dark'? 'white' : 'black',
        },
      },
      series: [
        {
          type: 'gauge',
          title: 'Live Power Factor',
          detail: {
            valueAnimation: true,
            formatter: '{value} A',
            color: 'inherit',
            offsetCenter: [0, '95%'],
            fontSize: 24,
          },
          data: [{ value: gauge[0]?.iavg||0, name: 'V' }],
          axisLine: {
            lineStyle: {
              width: 30,
              // color: [ [ 0.625, '#D4AF37' ], [ 0.75, '#048f04' ], [ 1, '#ab0207' ] ]
              color: [
                [0.625, '#e8c25a'], 
                [0.75, '#048f04'], 
                [1, '#fd666d'] 
            ],
              shadowBlur: 4,
              shadowColor: '#fff',
            },
          },
          min: 0,
          max: 80,
          pointer: { itemStyle: { color: 'auto' } },
          axisTick: { distance: -29, length: 30, lineStyle: { color: 'white', width: 1 } },
          splitLine: { distance: -29, length: 30, lineStyle: { color: 'white', width: 1 } },
          axisLabel: { 
            formatter:  function (value) {
                let numericLabels = axisLabels.map(label => parseFloat(label)); // Convert to numeric
                if (value === numericLabels[2]) return ''; // Hide 40%
                if (value === numericLabels[3]) return ''; // Hide 60%
                let midValue = ((min + max) / 2).toFixed(2); // Calculate 50% value
                if (value.toFixed(2) === midValue) return midValue; 
                if (numericLabels.includes(value)) return value.toFixed(2); // Show other values
                return ''; // Hide all others
            },
            color: isdarkMode === 'dark' ? 'white' : 'inherit',
            distance: 35,
            fontSize: 10
        }
        },
      ],
    };

    myChart.setOption(option);

    const resizeHandler = () => myChart.resize();
    window.addEventListener('resize', resizeHandler);

    return () => {
      window.removeEventListener('resize', resizeHandler);
      myChart.dispose();
    };
  }, [isdarkMode,gauge]);


  const UpdateGauge = (formValues) => {
    console.log(formValues);
    const url = `${APIConstants.UPDATE_GAUGE_DETAILS}`;
    console.log(url);

    makeRequest({
      type: APIConstants.POST,
      url: url,
      body: formValues,
    }).then((res) => {
      console.log(res);
      // setRefetch(!refetch)
      handleNotification(res.msg || "Updated successfully!",'success');
      getReposnse()
    }).catch((err) => {
      handleNotification("Something went wrong!",'error');

    });
  };

  return <div className={`overflow-hidden h-[280px] w-[270px] 
  shadow-allsides hover:scale-105 duration-150  flex-col justify-center items-center 
  ${ isdarkMode === 'dark'? 'bg-[#070721] ' : 'bg-[#fff]'}`}>
    <div
        className=" w-full mb-0 p-1  "
        style={{ 
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <p
          className={`${
            isdarkMode === "dark" ? "text-neutral-100" : "text-neutral-900"
          }  md:text-xl px-3 font-bold `}
          style={{ margin: 0 }}
        >
           {`${gauge[0]?.meterName}`||'Live Voltage'}
        </p>
       
          {/* <a onClick={() => showModal()}>
            <Space>
              <MoreOutlined
                className={`${
                  isdarkMode === "dark" ? "text-neutral-100" : "text-neutral-600"
                } px-3 font-extrabold`}
              />
            </Space>
          </a> */}
      </div>
      <div ref={chartRef} style={{ width: '100%', height: '260px' }} />;
      {/* <GaugeModal
          handleOk={handleOk} 
          handleCancel={handleCancel}
          open={isModalOpen}
          UpdateGauge={UpdateGauge}
        //   setRefetch={setRefetch}
        //   handleNotification={handleNotification}
        /> */}
  </div> 
};

export default Gauge3;

// const GaugeModal = ({
//     handleOk,
//     handleCancel,
//     open,
//     loading,
//     handleNotification,
//     UpdateGauge,
//   }) => {
//     console.log(open);
//     const mode = useSelector((state) => state.darkMode);
  
//     const { isdarkMode } = mode;
//     const { makeRequest } = useStoreUpdaterWithAPI();
  
//     const [group, setGroup] = useState([]);
//     const [converter, setConverter] = useState([]);
//     const [converterID, setConverterID] = useState();
//     const [meter, setMeter] = useState();
//     const [convertermeter, setConverterMeter] = useState([]);
//     const [groupMeter, setGroupMeter] = useState();
//     const [module, setModule]= useState()
    
  
   
//     // State to hold form values
//     const [formValues, setFormValues] = useState({});
//     const [form] = Form.useForm();
  
//     // Handle form submission
//     const onFinish = (values) => {
//       // setFormValues(values);
//       console.log(values);
//       const formData = (values) => {
//         return {
//           converterID: values.ConverterID?.key || null, 
//           gaugeID: '3' || null, 
//           meterID: values.MeterID.value || null 
//         };
//       };
//       const formValues = formData(values)
//       console.log(formValues);
//       handleOk(); 
//       UpdateGauge(formValues);
//     };
//     // Reset form values when modal is closed
//     useEffect(() => {
//       if (!open) {
//         form.resetFields();
//       } 
//     }, [open, form]);

  
//     useEffect(() => {
//       makeRequest({
//         type: APIConstants.POST,
//         url:`${APIConstants.ELECTRICAL_GROUP_DETAILS}`,
//       }).then((res) => {
//         console.log(res);
//         if(res){
//           setGroup(res);
//         }
//       });

//       makeRequest({ 
//         type: APIConstants.GET, 
//         // GetFlowSteamGropeMeterDetails?GroupID=81
//         url: `${APIConstants.GET_ELECTRICAL_CONVERTER_DETAILS}`
//       }).then((res) => {
//         console.log(res)
//         setConverter(res);
//       });

//     makeRequest({  
//         type: APIConstants.POST, 
//         // GetFlowSteamGropeMeterDetails?GroupID=81
//         url: `${APIConstants.ELECTRICAL_GROUP_NAME}?Module=1`
//       }).then((res) => {
//         console.log(res)
//         // setflowGroupDetailsResData(res);
//       });

//       makeRequest({  
//         type: APIConstants.GET, 
//         url: `${APIConstants.ELECTRICAL_PARAMETER_DETAILS}`
//       }).then((res) => {
//         console.log(res)
//         // setParameter(res);
//       });
//     }, []);
//     console.log(group)

//     useEffect(()=>{
//         makeRequest({ 
//             type: APIConstants.GET,  
//             // GetFlowSteamGropeMeterDetails?GroupID=81
//             url: `${APIConstants.ELECTRICAL_METERS_DETAILS}?ConverterID=${converterID}` 
//           }).then((res) => {
//             console.log(res) 
//             if(res&&res.length>0){
//                 setConverterMeter(res);
//             }
//           });
    
//         makeRequest({ 
//             type: APIConstants.POST,  
//             // GetFlowSteamGropeMeterDetails?GroupID=81
//             url: `${APIConstants.ELECTRICAL_GROUP_METER_DETAILS}?GroupID=${converterID}&Module=1`
//           }).then((res) => {
//             console.log(res)
//             setGroupMeter(res);
//           });
//       },[converterID])

//       const handleConverter=(e)=>{
//         console.log(e)
//         setConverterID(e.value)
//       }
//       const handleClose=()=>{
//         // setMeter()
//         // setConverter([])
//         // setConverterID()
//         handleCancel()
//       }
  
   
//     console.log(convertermeter)
//     console.log(converterID)
  
//     return (
//       <Modal
//         open={open}
//         title={<div className={` ${isdarkMode ? "text-white" : "text-black"}`}>
//             Search</div>}
//         // title="Add New Converter"
//         onOk={handleOk}
//         onCancel={handleCancel}
//         // width={800}
//         footer={null}
//         className={` custom-modal ${isdarkMode ? "dark-modal" : "light-modal"}`}
//       >
//         <Form
//           name="Gauge-form"
//           className="font-bold"
//           layout="horizontal"
//           style={{
//             maxWidth: 600,
//           }}
//           labelCol={{
//             span: 8,
//             offset: 0,
//           }}
//           labelAlign="left"
//           onFinish={onFinish}
//           form={form}
//         >
         
//           <Form.Item
//             label="Converter"
//             name="ConverterID"
//             rules={[
//               {
//                 required: true,
//                 message: "Please select a converter!",
//               },
//             ]}
//           >
//           <Select
//               // value={selectedValue}
//               onChange={handleConverter} 
//               // style={{ width: 200 }}
//               labelInValue
//               placeholder="Select a converter"
//               // dropdownClassName={isdarkMode ? 'select-dropdown-background' : 'light-mode-dropdown'}
//               // className={`  ${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'} w-80 `}
//               dropdownClassName={isdarkMode ? 'select-dropdown-background' : 'light-mode-dropdown'}
//               className={`  ${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'} w-80 `}
//             >
//               {converter.map((i) => (
//                 <Option key={i.siteID} value={i.siteID}>
//                   {i.siteName}
//                 </Option>
//               ))}
//             </Select>
//           </Form.Item>
//           <Form.Item
//             label="Meter"
//             name="MeterID"
//             rules={[
//               {
//                 required: true,
//                 message: "Please select a meter!",
//               },
//             ]}
//           >
//           <Select
//               // value={selectedValue}
//               // onChange={handleChange}
//               // style={{ width: 200 }}
//               labelInValue
//               placeholder="Select a meter"
//               // dropdownClassName={isdarkMode ? 'select-dropdown-background' : 'light-mode-dropdown'}
//               // className={`  ${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'} w-80 `}
//               dropdownClassName={isdarkMode ? 'select-dropdown-background' : 'light-mode-dropdown'}
//               className={`  ${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'} w-80 `}
//             >
//               {convertermeter.map((i) => (
//                 <Option key={i.metername} value={i.meterid}>
//                   {i.metername}
//                 </Option>
//               ))}
//             </Select>
//           </Form.Item>
  
  
         
  
//           <Form.Item
//             wrapperCol={{
//               offset: 16,
//               span: 16,
//             }}
//           >
//             <Button key="back" className="mr-3" onClick={handleClose}>
//               Cancel
//             </Button>
//             ,
//             <Button htmlType="submit" type="primary" loading={loading}>
//               Save
//             </Button>
//           </Form.Item>
//         </Form>
//       </Modal>
//     );
//   };